<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              label="Nome do Grupo"
              v-model="form.filters.nome"
              outlined
              dense
              @keyup.enter="buscarGrupos"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              label="Nome de Exibição"
              v-model="form.filters.nomeDeExibicao"
              outlined
              dense
              @keyup.enter="buscarGrupos"
            ></v-text-field>
          </v-col>
          <sca-select-ativo
            :cols="3"
            :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo', label: 'Situação' }"
            v-model="form.filters.ativo"
            @enter="buscarGrupos"
          ></sca-select-ativo>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              :text="'Buscar'"
              :icon="'mdi-magnify'"
              @click="buscarGrupos()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Incluir'"
              :icon="'mdi-plus'"
              @click="openDialogManterGrupo()"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="headers"
        :items="form.lists.listGrupos"
        :items-per-page="10"
        :footer-props="$footerProps"
        show-expand
        :no-data-text="noDataText"
        >
        <template v-slot:[`item.nome`]="{ item }">
          {{ item.nome }}
        </template>
        <template v-slot:[`item.nomeDeExibicao`]="{ item }">
          {{ item.nomeDeExibicao }}
        </template>
        <template v-slot:[`item.situacao`]="{ item }">
          <sca-label-ativo :ativo="item.ativo" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td class="permissoes" :colspan="headers.length">
            <v-chip-group active-class="primary--text" column>
              <v-chip class="chip-permissao" v-for="(permissao, i) in item.permissoes" :key="i">
                <v-icon class="permissao" small>mdi-checkbox-marked-circle-outline</v-icon>
                {{ permissao.nomeDeExibicao }}
              </v-chip>
            </v-chip-group>
          </td>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sca-tooltip
            :text="'Visualizar'"
            :icon="'mdi-eye-outline'"
            :small="true"
            @click="openDialogVisualizarGrupo(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="'Editar'"
            :icon="'mdi-pencil'"
            :small="true"
            @click="openDialogManterGrupo(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="`${item.situacao ? 'Inativar' : 'Ativar'}`"
            :icon="`${item.situacao ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`"
            :small="true"
            @click="inativarAtivarGrupo(item)"
          ></sca-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <CadastrarEditarGrupoDialog
      :visible="dialogManterGrupo.visible"
      :content="dialogManterGrupo.content"
      :edit="dialogManterGrupo.edit"
      @onClose="dialogManterGrupo.close()"
      @onSave="buscarGrupos()"
    ></CadastrarEditarGrupoDialog>
    <VisualizarGrupoDialog
      :visible="dialogVisualizarGrupo.visible"
      :content="dialogVisualizarGrupo.content"
      @onClose="dialogVisualizarGrupo.close()"
    ></VisualizarGrupoDialog>
  </div>
</template>

<script>
import { Dialog } from '~/commons/classes/dialog';
import { Grupo } from '~/commons/classes/grupo';
import GrupoService from '~/services/grupo.service';
import datatablesMixin from '~/mixins/datatables.mixin';
import CadastrarEditarGrupoDialog from "./dialogs/CadastrarEditarGrupoDialog.vue";
import VisualizarGrupoDialog from "./dialogs/VisualizarGrupoDialog.vue";

export default {
  name: "ManterGruposView",
  mixins: [GrupoService, datatablesMixin],
  components: {
    CadastrarEditarGrupoDialog,
    VisualizarGrupoDialog,
  },
  data: () => ({
    dialogManterGrupo: Dialog.Build(),
    dialogVisualizarGrupo: Dialog.Build(),
    form: {
      filters: {
        nome: null,
        nomeDeExibicao: null,
        ativo: null,
      },
      lists: {
        listGrupos: []
      }
    },
    headers: [
      { text: "Nome do Grupo", align: "center", value: "nome" },
      { text: "Nome de Exibição", align: "center", value: "nomeDeExibicao" },
      { text: "Situação", align: "center", value: "situacao", sortable: false },
      { text: "Permissões", align: "center", value: "data-table-expand" },
      { text: "Ações", align: "center", value: "acoes", sortable: false },
    ]
  }),
  methods: {
    openDialogManterGrupo(grupo) {
      grupo
        ? this.$visualizarGrupos(grupo).then(({ data }) => this.dialogManterGrupo.open(new Grupo(data.resposta.grupo), true))
        : this.dialogManterGrupo.open(Grupo.Build());
    },
    openDialogVisualizarGrupo(grupo) {
      this.$visualizarGrupos(grupo).then(({ data }) => (this.dialogVisualizarGrupo.open(data.resposta.grupo)));
    },
    buscarGrupos() {
      this.$buscarGrupos({ params: this.form.filters }).then(({ data }) => (this.form.lists.listGrupos = data.grupos));
    },
    inativarAtivarGrupo(grupo) {
      this.$swal({
        text: `Deseja ${grupo.ativo ? "inativar" : "ativar"} o registro?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.$inativarAtivarGrupo(grupo.id).then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.buscarGrupos();
        });
      });
    },
    resetForm() {
      this.$resetForm();
      this.form.lists.listGrupos = [];
      this.form.filters.ativo = null;
    },
  },
};
</script>
